export default __webpack_public_path__ + "static/media/Avengers_logo.9eaf2193.png";